import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { STAGES, PRIORITIES, findStage, findPriority } from './crmConstants';

export function StageSelector({ current, onChange }) {
  const [open, setOpen] = useState(false);
  const stage = findStage(current);
  return (
    <div className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-sans font-semibold transition-colors"
        style={{ backgroundColor: stage.bg, color: stage.color, border: `1px solid ${stage.color}30` }}
        data-testid="stage-selector"
      >
        {stage.label} <ChevronDown size={11} />
      </button>
      {open && (
        <div className="absolute top-full left-0 mt-1 bg-white border border-earth/10 rounded-lg shadow-lg z-20 py-1 min-w-[140px]">
          {STAGES.map(s => (
            <button
              key={s.key}
              onClick={() => { onChange(s.key); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-xs font-sans flex items-center gap-2 hover:bg-cream/50 ${s.key === current ? 'font-bold' : ''}`}
              data-testid={`stage-${s.key}`}
            >
              <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: s.color }} />
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const EMPTY_PRIORITY_STYLE = { backgroundColor: '#f5f5f5', color: '#999', borderColor: '#e0e0e0' };

export function PriorityBadge({ priority, onChange }) {
  const [open, setOpen] = useState(false);
  const p = findPriority(priority);
  const pick = (key) => { onChange(key); setOpen(false); };
  return (
    <div className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1 px-2.5 py-1 rounded-md text-[10px] font-sans font-semibold transition-colors border"
        style={p ? { backgroundColor: p.bg, color: p.color, borderColor: p.color + '30' } : EMPTY_PRIORITY_STYLE}
        data-testid="priority-selector"
      >
        {p ? <><p.icon size={10} /> {p.label}</> : 'Set Priority'} <ChevronDown size={9} />
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-1 bg-white border border-earth/10 rounded-lg shadow-lg z-20 py-1 min-w-[120px]">
          {PRIORITIES.map(pr => (
            <button key={pr.key} onClick={() => pick(pr.key)} className="w-full text-left px-3 py-2 text-xs font-sans flex items-center gap-2 hover:bg-cream/50" data-testid={`priority-${pr.key}`}>
              <pr.icon size={11} style={{ color: pr.color }} /> {pr.label}
            </button>
          ))}
          {priority && (
            <button onClick={() => pick('')} className="w-full text-left px-3 py-2 text-xs font-sans text-earth/40 hover:bg-cream/50 border-t border-earth/5" data-testid="priority-clear">
              Clear Priority
            </button>
          )}
        </div>
      )}
    </div>
  );
}
